import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-2" }
const _hoisted_3 = { class: "col-10" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Category name", -1)
const _hoisted_9 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, "Edit category " + _toDisplayString(_ctx.id), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, { to: { name: 'categories' } }, {
          default: _withCtx(() => [
            _createTextVNode("Back to Categories")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.errorMsg != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoryName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.categoryName]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("input", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitClicked())),
                  type: "submit",
                  value: "Create",
                  class: "btn btn-primary"
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}